export default __webpack_public_path__ + "static/media/_PublicChargingLane.b98776dd.jpeg";